module.exports = __webpack_public_path__ + "static/img/xl_btn2.24360fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/xl_btn2.png
// module id = 3rSF
// module chunks = 7